var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 87.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#Gradient_bez_nazwy_76);}.cls-3{fill:url(#Gradient_bez_nazwy_81);}.cls-4,.cls-5{mix-blend-mode:darken;opacity:0.47;}.cls-4{fill:url(#Gradient_bez_nazwy_33);}.cls-5{fill:url(#Gradient_bez_nazwy_33-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_76",
    y1: 43.86,
    x2: 141.73,
    y2: 43.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6365ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6365ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7039ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#791adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7e07d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8000d4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_bez_nazwy_81",
    cx: 408.82,
    cy: -135.28,
    r: 66.47,
    gradientTransform: "translate(-269.25 110.1) scale(0.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15fffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#15fffb",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#15fffb",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#15fffb",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#15fffb",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15fffb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_33",
    x1: -2326.33,
    y1: 45.93,
    x2: -2285.78,
    y2: 58.85,
    gradientTransform: "matrix(-1, 0, 0, 1, -2283.08, -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_33-2",
    x1: 534.94,
    y1: 19.9,
    x2: 575.48,
    y2: 32.83,
    gradientTransform: "translate(-432.2 -1)",
    xlinkHref: "#Gradient_bez_nazwy_33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.73 14.99 129.48 14.99 129.48 14.98 113.49 14.98 113.48 14.98 106.08 14.98 114.37 0 34.92 0.03 43.23 14.98 89 14.98 66.36 55.93 57.93 41 23.76 41 30.32 29.93 51.68 29.93 43.23 14.98 22.76 14.98 0 55.95 48.16 55.95 65.86 87.73 97.82 29.94 105.18 29.94 90.72 55.95 106.17 55.95 120.97 29.94 133.28 29.94 141.73 14.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "141.73 14.99 129.48 14.99 129.48 14.98 113.49 14.98 113.48 14.98 106.08 14.98 114.37 0 34.92 0.03 43.23 14.98 89 14.98 66.36 55.93 57.93 41 23.76 41 30.32 29.93 51.68 29.93 43.23 14.98 22.76 14.98 0 55.95 48.16 55.95 65.86 87.73 97.82 29.94 105.18 29.94 90.72 55.95 106.17 55.95 120.97 29.94 133.28 29.94 141.73 14.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "15.92 41.05 15.23 55.95 48.16 55.95 40.7 41 15.92 41.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.06 15.03 130.75 29.93 97.82 29.93 106.08 14.98 130.06 15.03"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvt);
export default __webpack_public_path__ + "static/media/cvt.cf656825717d282299fc154cfa4e2534.svg";
export { ForwardRef as ReactComponent };